import CallError from '../../utils/CallError';
import { getBadParams, getMissingKeys } from '../../utils/general';
import { settings } from './setup';

/**
 * Gets the ECAPPS for a specific org
 * @param {object} params - an object of params
 * @param {string} params.accessToken - User IMS token
 * @param {string} params.appId - Id of the app
 * @param {string} params.versionId - Version of the app
 * @param {string} params.region - User region
 * @param {string} params.appType - Type of the app
 * @param {string} params.email - User email
 */
export default async (params = {}, signal = null) => {
  const requiredParams = ['appId', 'versionId', 'region', 'appType', 'email', 'accessToken'];
  const paramsRules = {
    appId: { allowedTypes: ['string'] },
    versionId: { allowedTypes: ['string'] },
    region: { allowedTypes: ['string'] },
    appType: { allowedTypes: ['string'] },
    email: { allowedTypes: ['string'] },
    accessToken: { allowedTypes: ['string'] },
  };
  const missingParams = getMissingKeys(params, requiredParams);
  let badParams = [];
  if (Object.keys(params).length) {
    badParams = getBadParams(params, paramsRules);
  }
  if (missingParams.length || badParams.length) {
    throw new CallError('params', null, 404, { missingParams, badParams });
  }
  const response = await fetch(
    `${settings.endpoint}/v1/generateUniqueId?appId=${params.appId}&appVersionId=${params.versionId}&region=${params.region}&appType=${params.appType}&email=${params.email}&api_key=${settings.apiKey}`,
    {
      signal,
      headers: { Authorization: params.accessToken },
    }
  );
  let content = await response.text();
  try {
    content = JSON.parse(content);
  } catch (e) {
    // response is not json
  }

  if (!response.ok) {
    throw new CallError('http', content, response.status, { message: response.statusText });
  } else {
    return content;
  }
};
